import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MmuUserRoles } from '../../models';

@Component({
  selector: 'mmu-plan-permission-dialog',
  templateUrl: './mmu-plan-permission-dialog.component.html',
  styleUrls: ['./mmu-plan-permission-dialog.component.scss']
})
export class MmuPlanPermissionDialogComponent {
  readonly roles = MmuUserRoles;

  constructor(private modal: NgbActiveModal) {}

  /** Dismisses the modal and rejects the modal result promise */
  dismiss(): void {
    this.modal.dismiss();
  }
}
